let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hHprL")).then(() => parcelRequire('crFp4'));